import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

import { keepDocumentLanguage } from "./documentLanguage";
import { LANGUAGE_CODES } from "./languages";

i18n
  .use(initReactI18next)
  .use(backend)
  .use(LanguageDetector)
  .init({
    // A browser in a language the editor has (es-419 → es) gets it; any other gets English. A text not yet
    // translated to a language shows in English too (new texts reach es/fr/de/it when their feature is done)
    supportedLngs: LANGUAGE_CODES,
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    // In dev, bust the browser cache so edited translation files are always refetched
    ...(import.meta.env.DEV && { backend: { queryStringParams: { v: Date.now() } } }),
  });

// The page's <html lang> follows the editor's language (index.html starts as Portuguese)
keepDocumentLanguage(i18n);

export default i18n;
